import { Link } from 'react-router-dom';
import type { Drama } from '@/mocks/dramas';

interface DramaCardProps {
  drama: Drama;
}

export default function DramaCard({ drama }: DramaCardProps) {
  return (
    <Link
      to={`/drama/${drama.id}`}
      className="group block"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200 mb-3">
        <img
          src={drama.posterImage}
          alt={drama.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-2 right-2">
          <span className="inline-block px-2 py-0.5 text-xs font-medium rounded-full bg-primary-500 text-white">
            {drama.rating}
          </span>
        </div>
        {drama.status === '已完结' && (
          <div className="absolute top-2 left-2">
            <span className="inline-block px-2 py-0.5 text-xs rounded-full bg-background-950/70 text-background-50">
              {drama.status}
            </span>
          </div>
        )}
        <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-black/80 to-transparent"></div>
        <div className="absolute bottom-2 left-2 right-2">
          <p className="text-xs text-white/80">{drama.updateInfo}</p>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
        {drama.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{drama.shortDescription}</p>
    </Link>
  );
}